<template>
  <div class="messagePage">
    <div class="top-container">
      <div class="top">
        <img :src="back" alt="" @click="goBack">
        <div class="title">{{$t('lang.menu.Message')}}</div>
      </div>
      <div class="ReadAll" v-if="canReadAll" @click="gotoReadAll">
        <img :src="ReadAll"/>
        <div class="text">{{$t('lang.message.readAll')}}</div>
      </div>
      <div class="ReadAll-disable" v-else>
        <img :src="NotReadAll"/>
        <div class="text">{{$t('lang.message.readAll')}}</div>
      </div>
    </div>
    <div class="messageContainer">
      <div class="tabList">
        <div
          class="tab"
          :class="{'tabSelected': tabSelected === key}"
          v-for="(key, index) in tabList"
          :key="index"
          @click="selectTab(key)">
          {{$t('lang.setting.'+key)}}
          <div class="unreadNum" v-if="unreadNum[key]">
            {{unreadNum[key]}}
          </div>
          <div class="tabhint" v-if="key.toLowerCase() === 'system' && redPoints['system'] === 1"></div>
          <div class="tabhint" v-if="key.toLowerCase() === 'event' && redPoints['event'] === 1"></div>
          <div class="tabhint" v-if="key.toLowerCase() === 'personal' && redPoints['personal'] === 1"></div>
        </div>
      </div>
      <Loadmore
        v-if="messageList&&messageList.length>0"
        :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
        :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
        :bottomLoadingText="$t('lang.loadingStatus.loading')"
        :auto-fill="false"
        :bottom-method="fetchMessage"
        :bottom-all-loaded="hasLoadAll"
        style="width: 100vw;padding-top: 10px;"
        ref="loadmore">
        <div
          class="messageItem"
          :class="{'messageRead': item.Status===MessageStatus.Read}"
          v-for="(item, index) in messageList"
          :key="index"
          @click="handelShowDetail(item, index)">
          <div class="messageLeftBody">
            <div class="message">
              <div class="subject">
                <span>{{ welcomeMessage(item.Title) }}</span>
                <img :src="item.IsRead?paperclip2:paperclip" v-if="formatObj(item) > 0" alt=""/>
              </div>
              <div class="desc" v-html="formatText(item.Content)"
                   :style="$store.state.locale==='IN'&&item.Title.indexOf('lang.welcome.title')>-1?'line-height:3.7vw':''"/>
            </div>
          </div>
          <div class="messageRightBody">
            <div class="time">{{ formatTime(item.CreateTime) }}</div>
            <div class="cashBonusItem" v-if="formatObj(item) > 0||getDiscount(item)">
              <div class="discount" v-if="getDiscount(item)"><img :src="discount" alt=""/></div>
              <div class="bonus" v-if="formatObj(item) > 0"><img :src="bonus" alt=""/></div>
              <img :src="right" class="right" alt=""/>
            </div>
            <div class="cashBonusItem" v-else>
              <img :src="mess" class="mess" alt=""/>
              <img :src="right" class="right" alt=""/>
            </div>
          </div>
          <div class="redHint" v-if="!item.IsRead"></div>
        </div>
        <div class="bottomLogo" v-if="hasLoadAll && messageList.length">
        </div>
        <div class="showMore" v-if="!hasLoadAll"><img :src="showMore" alt=""></div>
      </Loadmore>
      <div v-else class="noMsg">
        <img :src="noMsg" alt="">
        <div class="text">{{ $t('lang.message.noMessage') }}</div>
      </div>
    </div>
    <MessageDetail :detail="detail" v-if="showDetail" :closeDetail="detailClose"/>
  </div>
</template>

<script>
import {Loadmore} from 'mint-ui'
import TopBack from '@/components/TopBack/index'
import MessageDetail from './Children/messageDetail'
import {MessageStatus, MessageCategory} from '@/constant'
import request2 from '@/service2'
import logo from '@/assets/images/common/logo1.svg'
import showMore from '@/assets/images/common/showMore.gif'
import mess from '@/assets/images/innerMessage/mess.svg'
import bonus from '@/assets/images/innerMessage/bonus.svg'
import discount from '@/assets/images/innerMessage/discount.svg'
import right from '@/assets/images/innerMessage/right.svg'
import ReadAll from '@/assets/images/innerMessage/readAll.svg'
import paperclip from '@/assets/images/innerMessage/paperclip.svg'
import paperclip2 from '@/assets/images/innerMessage/paperclip2.svg'
import NotReadAll from '@/assets/images/innerMessage/notReadAll.svg'
import back from '@/assets/images/common/back.svg'
import Bonus from '../Games/bonus.vue'
import noMsg from '@/assets/images/innerMessage/noMsg.png'
import {fetchBalance} from '@/utils'

export default {
  name: 'Message',
  data () {
    return {
      MessageStatus,
      logo,
      noMsg,
      tabList: ['system', 'event', 'personal'],
      tabSelected: 'system',
      messageList: [],
      redPoints: [],
      unreadNum: {
        System: 0,
        Event: 0,
        Personal: 0
      },
      skipNum: 0,
      takeNum: 5,
      hasLoadAll: true,
      showDetail: false,
      detail: {},
      firstLoad: true,
      canReadAll: this.$store.state.hasCashBonus,
      fetchBalance,
      showMore,
      NotReadAll,
      paperclip2,
      paperclip,
      ReadAll,
      back,
      mess,
      right,
      discount,
      bonus
    }
  },
  watch: {
    '$store.state.hasCashBonus': function (n) {
      this.canReadAll = n
    }
  },
  computed: {
    tabCase () {
      return (key) => {
        return this.tabSelected === key ? key.toUpperCase() : key
      }
    }
  },
  components: {
    Bonus,
    TopBack,
    Loadmore,
    MessageDetail
  },
  mounted () {
    if (this.$route.query.tabSelected && this.$route.query.tabSelected === 'personal') {
      this.tabSelected = 'personal'
    }
    let resultInfo = JSON.parse(sessionStorage.getItem('resultInfo'))
    if (resultInfo) {
      this.handelShowDetail(resultInfo)
    }
    this.fetchMessage()
  },
  methods: {
    formatTime (dateTime) {
      let parts = dateTime.split('T')
      let dateParts = parts[0].split('-')
      let year = dateParts[0]
      let month = dateParts[1]
      let day = dateParts[2]
      let time = parts[1].substring(0, 5)
      return `${day}/${month}/${year} ${time}`
    },
    formatText (text) {
      text = this.welcomeMessage(text)
      if (text.includes('《') && text.includes('》')) {
        text = text.replace(/《.*?》/g, '')
      }
      return text.replace(/\n/g, '<br>')
    },
    welcomeMessage (text) {
      if (text.toLowerCase().indexOf('lang.welcome.title') > -1) {
        text = text.replace('$t(\'lang.welcome.title\')', this.$t('lang.welcome.title'))
      } else if (text.toLowerCase().indexOf('lang.welcome.message') > -1) {
        text = text.replace('$t(\'lang.welcome.message\')', this.$t('lang.welcome.message'))
      }
      return this.removeTags(text)
    },
    removeTags (html) {
      let doc = new DOMParser().parseFromString(html, 'text/html')
      return doc.body.textContent || ''
    },
    selectTab (key) {
      this.tabSelected = key
      this.skipNum = 0
      this.messageList = []
      this.firstLoad = true
      this.fetchMessage()
      this.$store.commit('setMsgCountFresh', !this.$store.state.msgCountFresh)
    },
    goBack () {
      this.$router.go(-1)
    },
    gotoReadAll () {
      // this.canReadAll = !this.canReadAll
      const url = '/innovation/newmessage/oneclickcollection'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request2('post', url, data, true).then(res => {
        if (res) {
          this.messageList = []
          this.skipNum = 0
          this.firstLoad = false
          this.fetchBalance()
          this.fetchMessage()
          this.$store.commit('setMsgCountFresh', !this.$store.state.msgCountFresh)
        }
      })
    },
    detailClose () {
      sessionStorage.removeItem('resultInfo')
      this.showDetail = false
      this.$store.commit('setMsgCountFresh', !this.$store.state.msgCountFresh)
      this.messageList = []
      this.skipNum = 0
      this.firstLoad = false
      this.fetchMessage()
    },
    fetchMessage () {
      const url = '/innovation/newmessage/personalmsgs'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        skip: this.skipNum,
        take: this.takeNum,
        category: this.tabSelected // status filter. 0: Undefined(all), 1: NotRead, 2: Read
      }
      request2('post', url, data).then(res => {
        this.messageList = this.messageList.concat(res.UserMessageDetails)
        this.redPoints = {}
        if (res && res.UnreadInfos) {
          res.UnreadInfos.forEach((e) => {
            this.redPoints[e.Type] = e.HasRedPoint
          })
        }
        this.skipNum += this.takeNum
        this.hasLoadAll = this.skipNum >= res.Total
        if (!this.firstLoad && this.$refs.loadmore) {
          this.$refs.loadmore.onBottomLoaded()
        }
        this.firstLoad = false
      })
    },
    formatObj (item) {
      return item && item.FundsAmount && item.FundsAmount > 0
    },
    getDiscount (item) {
      return item && item.VoucherRate && item.VoucherRate > 0
    },
    handelShowDetail (detail, index) {
      this.detail = detail
      this.showDetail = true
    },
    fetchUnreadCount () {
      const url = '/innovation/message/getnotreadmessagescount'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request2('post', url, data).then(res => {
        res.NotReadMessagesCount.forEach(item => {
          Object.keys(MessageCategory).forEach(key => {
            if (MessageCategory[key] === item.Category) this.unreadNum[key] = item.Count
          })
        })
      })
    },
    unclaimedCashBonus () {
      const user = localStorage.getItem('userInfo')
      if (user !== null) {
        const url = '/innovation/newmessage/unclaimedcashbonus'
        const data = {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
          messageType: 'system'
        }
        request2('post', url, data).then(res => {
          if (res > 0) {
            this.$store.commit('setIfHaveCashOrBonus', true)
          } else {
            this.$store.commit('setIfHaveCashOrBonus', false)
          }
        })
      }
    },
    updateWhenClaimed (messageId) {
      const hasClaimed = messageId !== null
      if (hasClaimed) {
        var msg = this.messageList.find(m => m.Id === messageId)
        var jason = '{"CashorBonusAmount":' + msg.CashorBonusAmount + '}' // 注意：此种赋值方式不是引用
        var obj = JSON.parse(jason)
        for (let j = 0; j < obj.CashorBonusAmount.cbs.length; j++) {
          const subitem = obj.CashorBonusAmount.cbs[j]
          subitem.IsClaimed = true
        }
        msg.CashorBonusAmount = JSON.stringify(obj.CashorBonusAmount)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .messagePage {
    position: relative;
    top: 56px;
    height: calc(100vh - 56px);
    .top-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 93vw;
      margin: 0 auto;

      .top {
        display: flex;
        align-items: center;
        height: 15vw;

        .title {
          margin-left: 5vw;
          color: #F6D9AA;
          font-size: 5.277vw;
          font-weight: 700;
        }

        img {
          width: 8vw;
        }
      }

      .ReadAll {
        display: flex;
        margin-right: 2vw;

        img {
          width: 5.2vw;
        }

        .text {
          font-size: 4.8vw;
          font-weight: 500;
          letter-spacing: -0.02em;
          text-align: left;
          color: #E4D9AA;
        }
      }

      .ReadAll-disable {
        display: flex;
        margin-right: 2vw;

        img {
          width: 5.2vw;
        }

        .text {
          font-size: 4.722vw;
          font-weight: 500;
          letter-spacing: -0.02em;
          text-align: left;
          color: #515151;
        }
      }
    }

    .messageContainer {
      background-color: #161616;
      height: calc(100vh - 15vw - 56px);
      overflow: auto;

      .tabList {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        width: 88vw;
        display: flex;
        text-align: center;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        z-index: 0;
        .tab {
          flex: 1;
          position: relative;
          padding: 0 4.166vw 1.366vw;
          font-size: 4.444vw;
          line-height: 5.833vw;
          color: #686868;
          border-bottom: 0.555vw solid rgba(255, 255, 255, 0);
          .tabhint{
            position: absolute;
            width: 3.333vw;
            height: 3.333vw;
            border-radius: 1.667vw;
            background-color: red;
            top: 0;
            right: 2.222vw;
          }
        }
        .tabSelected {
          color: #F6D9AA;
          line-height: 5.833vw;
          font-weight: 500;
          border-bottom: 0.555vw solid #F6D9AA;
        }
        .unreadNum {
          position: absolute;
          top: -15px;
          left: calc(50% + 40px);
          transform: translateX(-50%);
          padding: 0 4px;
          font-size: 10px;
          line-height: 15px;
          color: #fff;
          background-color: #ff0000;
          border-radius: 30px;
        }
      }

      .noMsg {
        position: relative;
        top: 36vw;
        left: 50%;
        transform: translate(-50%);
        width: 43vw;

        img {
          margin: 0 5.8vw;
          width: 31.4vw;
        }

        .text {
          margin-top: 2vw;
          text-transform: capitalize;
          text-align: center;
          font-size: 4.72vw;
          font-weight: 500;
          line-height: 5.713vw;
          letter-spacing: 0.03em;
          color: #3B3B3B;
        }
      }
      .messageItem {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        width: 90.513vw;
        height: 22.777vw;
        color: #F6D9AA;
        background-color: #2F2F2F;
        border-radius: 1.666vw;
        margin-bottom: 3.333vw;
        display: flex;
        justify-content: flex-start;
        padding: 2.7vw 4.1vw;
        overflow: visible;

        .messageLeftBody {
          overflow: hidden;
          flex: 1.90;
          width: 53.888vw;
          .message {
            width: 53.888vw;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;

            .subject {
              width: 53.888vw;
              color: #F6D9AA;
              font-size: 5vw;
              line-height: 5vw;
              font-weight: 700;
              display: flex;
              justify-content: flex-start;
              span {
                letter-spacing: -0.02em;
                text-align: left;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding-right: 1.2vw;
              }
              img{
                width: 3.647vw;
              }

            }
            .desc{
              padding-top: 5vw;
              width: 53.888vw;
              height: 11.666vw;
              font-size: 3.33vw;
              line-height: 3.33vw;
              font-weight: 400;
              text-align: left;
              color: #B6B6B6;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }

        .messageRightBody {
          flex: 1;
          width: 65px;
          .time{
            margin-top: 1.4vw;
            width: 100%;
            text-align: right;
            font-size: 3.33vw;
            color: #646464;
            white-space: nowrap;
          }
          .cashBonusItem {
            margin-top: 1.2vw;
            width: 100%;
            height: 15vw;
            position: relative;
            overflow: visible;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;

            .bonus {
              position: relative;
              margin-right: -2vw;
              width: 19vw;
              overflow: hidden;
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
              padding-bottom: 2vw;

              img {
                width: 16vw;
              }
            }
            .discount {
              position: relative;
              width: 20vw;
              display: flex;
              justify-content: flex-end;
              align-items: flex-start;
              overflow: hidden;
              margin-right: 1vw;
              padding-bottom: 4.5vw;
              img {
                width: 9.5vw;
              }
            }

            .mess{
              position: relative;
              width: 10.647vw;
              margin-right: 0.5vw;
              margin-bottom: 4vw;
            }

            .right {
              position: relative;
              width: 2.889vw;
              margin-bottom: 6vw;
            }

          }
        }

        .redHint {
          position: absolute;
          top: -1vw;
          right: -1vw;
          width: 2.777vw;
          height: 2.777vw;
          border-radius: 50%;
          background-color: #F23042;
        }
      }

      .messageRead {
        background-color: #202020 !important;

        div {
          color: #686868 !important;
        }
      }

      .showMore {
        text-align: center;

        img {
          width: 10px;
        }
      }

      .bottomLogo {
        text-align: right;
        height: 10vw;
        margin-right: 4.5vw;
        margin-bottom: 2.5vw;
        display: none;

        img {
          width: 40px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Message/index.vue